<template>
  <div class="col-item">
    <div class="col-title">
      <slot name="title" v-if="$slots.title"></slot>
      <h4 v-else class="name">{{ title }}</h4>
      <div class="btns">
        <el-button v-if="clearable" class="btn clear" type="text" @click="emit('clear')">清空</el-button>
        <el-button v-if="configable" :disabled="configDisabled" class="btn config" type="text" @click="emit('show-config-modal')">配置</el-button>
        <slot name="custom-btn"></slot>
      </div>
    </div>

    <slot></slot>
  </div>
</template>

<script setup>
import { toRefs } from 'vue'
// eslint-disable-next-line
const props = defineProps({
  title: String,
  clearable: {
    type: Boolean,
    default: true
  },
  configable: {
    type: Boolean,
    default: true
  },
  configDisabled: {
    type: Boolean,
    default: false
  }
})

const { title } = toRefs(props)

// eslint-disable-next-line
const emit = defineEmits(['clear', 'show-config-modal'])
</script>

<style lang="scss" scoped>
.col-item {
  border: 1px solid #e8e8e8;
  border-radius: 4px;
}
::v-deep .col-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  white-space: nowrap;
  background: #f5f5f5;
  padding: 8px 6px;
  .name {
    color: #000;
    font-size: 14px;
    line-height: 20px;
    font-weight: 600;
  }
  .btns {
    display: flex;
    align-items: center;
    .el-button {
      padding: 0;
      cursor: pointer;
      font-size: 14px;
      &.clear {
        color: #505c73;
      }
    }
  }
}
</style>
